export const LOGIN_TOKEN = 'login-token';
export const COMMIT_TOKEN = 'commit-token';
export const SUPPLIER_CODE = 'supplier-code';

function isEmptyObject(e) {
  let t;

  for (t in e) {
    if (e.hasOwnProperty(t)) {
      return !1;
    }
  }

  return !0;
}

// LocalStorage
export function setVariant(k, v) {
  if (!isEmptyObject(k)) {
    window.localStorage.setItem(k, JSON.stringify(v));
  }
}

export function removeVariant(k) {
  window.localStorage.removeItem(k);
}

export function hasVariant(k) {
  const result = window.localStorage.getItem(k);

  return !isEmptyObject(result);
}

export function getVariant(k) {
  try {
    if (hasVariant(k)) {
      return JSON.parse(window.localStorage.getItem(k));
    } else {
      return null;
    }
  } catch (err) {
    console.log('getVariantgetVarianterr', err);
  }
}

// SessionStorage
export function setVariantSession(k, v) {
  if (!isEmptyObject(k)) {
    window.sessionStorage.setItem(k, JSON.stringify(v));
  }
}

export function removeVariantSession(k) {
  window.sessionStorage.removeItem(k);
}

export function hasVariantSession(k) {
  const result = window.sessionStorage.getItem(k);

  return !isEmptyObject(result);
}

export function getVariantSession(k) {
  if (hasVariantSession(k)) {
    return JSON.parse(window.sessionStorage.getItem(k));
  } else {
    return null;
  }
}
